import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ProjectDetailLocationGridPage } from './project-detail-location-grid';
import { BodyModule, GridModule, SharedModule } from '@progress/kendo-angular-grid';
import { PtKendoModule } from '../../../../_foundation/kendo/modules/pt.kendo.module';

@NgModule({
  declarations: [
    ProjectDetailLocationGridPage,
  ],
  imports: [
    IonicPageModule.forChild(ProjectDetailLocationGridPage),
    GridModule,
    SharedModule,
    BodyModule,
    PtKendoModule
  ],
})
export class ProjectDetailLocationGridPageModule {}



// WEBPACK FOOTER //
// ./src/pages/setup/project-details/project-detail-location-grid/project-detail-location-grid.module.ts